export default __webpack_public_path__ + "static/media/panelsM@2x-min.f58ba9f0.png";